<div class="item-grid-container ">

  <form [formGroup]="addRetailerForm" class="p-0" (ngSubmit)="onSubmit()">
    <h5 class="content-label-each" translate>
      pages.newRetailer.businessInformation
    </h5>
    <div class="buss-info-details content-details-blk">
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.businessName<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                minlength=5
                maxlength=50
                placeholder="{{
                  'pages.newRetailer.enterBusinessname' | translate
                }}"
                formControlName="businessName"
                required
              />
            </mat-form-field>
            <div *ngIf="f.businessName.touched && f.businessName.invalid">
                <mat-hint class="text-danger ms-2" *ngIf="f.businessName.errors.required">
                  <span translate
                    >pages.newRetailer.businessnameisrequired</span
                  ></mat-hint
                >
                <mat-hint class="text-danger ms-2" *ngIf="f.businessName.hasError('minlength') ||f.businessName.hasError('maxlength')"
                  >Min length: 5 & Max length : 50</mat-hint
                >
                <!-- <span *ngIf="f.businessName.errors">
      
                  {{f.businessName.errors | json}}
                </span> -->
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.dbaName<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                required
                minlength=5
                maxlength=50
                placeholder="{{'pages.AddRetailer.EnterDBAname' | translate }}"
                [ngModel]="addRetailerForm.value.businessName"
                formControlName="dbaName"
              />
            </mat-form-field>
            <div *ngIf="f.dbaName.touched && f.dbaName.invalid">
              <div *ngIf="f.dbaName.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{'pages.placeholders.DBANameisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.businessType<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <!-- <mat-label> Business type </mat-label> -->
              <mat-select
                formControlName="businessType"
                placeholder="{{
                  'pages.newRetailer.selectBusiness' | translate
                }}"
              >
                <mat-option
                  *ngFor="let businessType of businessTypes"
                  [value]="businessType"
                >
                  {{ businessType }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="f.businessType.touched && f.businessType.invalid">
              <div *ngIf="f.businessType.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Businesstypeisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.businessNumber<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              
              <input
                matInput
                [textMask]="{ mask: phone }"
                required
                formControlName="businessNumber"
                placeholder="{{'pages.AddRetailer.Enterbusinessphonenumber' | translate }}"
              />
              <!-- <span matPrefix>+1</span> -->
            </mat-form-field>
            <div *ngIf="f.businessNumber.touched && f.businessNumber.invalid">
              <div *ngIf="f.businessNumber.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Businessnumberisrequired' | translate }}</mat-hint
                >
              </div>
              <div *ngIf="f.businessNumber.errors.pattern">
                <mat-hint class="text-danger ms-2"
                  >{{ 'pages.placeholders.PleaseEnter10digitMobileNumber' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.address<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                required
                formControlName="address"
                placeholder="{{'pages.AddRetailer.Enteraddress' | translate }}"
              />
            </mat-form-field>
            <div *ngIf="f.address.touched && f.address.invalid">
              <div *ngIf="f.address.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Addressisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.city<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                required
                formControlName="city"
                placeholder="{{'pages.AddRetailer.Entercity' | translate }}"
              />
            </mat-form-field>
            <div *ngIf="f.city.touched && f.city.invalid">
              <div *ngIf="f.city.errors.required">
                <mat-hint class="text-danger ms-2"> {{ 'pages.placeholders.Cityisrequired' | translate }}</mat-hint>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.state<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <mat-select formControlName="state" placeholder="{{'pages.AddRetailer.SelectState' | translate }}">
                <mat-option *ngFor="let state of usStateZips" [value]="state">
                  {{ state }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="f.state.touched && f.state.invalid">
              <div *ngIf="f.state.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Stateisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.zipCode<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                required
                type="text"
                placeholder="{{ 'pages.newRetailer.enterZipCode' | translate }}"
                formControlName="zipCode"
              />
            </mat-form-field>
            <div *ngIf="f.zipCode.touched && f.zipCode.invalid">
              <div *ngIf="f.zipCode.errors.required">
                <mat-hint class="text-danger ms-2"> {{ 'pages.placeholders.ZIPisrequired' | translate }}</mat-hint>
              </div>
              <div *ngIf="f.zipCode.errors.pattern">
                <mat-hint class="text-danger ms-2"
                  >{{ 'pages.placeholders.InvalidZIPformat' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
        
      </div>

      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.businessCertificate<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                required
                formControlName="businessCertificate"
                placeholder="{{ 'pages.placeholders.Enterbusinesscertificate' | translate }}"
              />
            </mat-form-field>
            <div
              *ngIf="
                f.businessCertificate.touched && f.businessCertificate.invalid
              "
            >
              <div *ngIf="f.businessCertificate.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Businesscertificateisrequired' | translate }}</mat-hint
                >
              </div>
              <!-- <div *ngIf="f.businessCertificate.errors.pattern">
                <mat-hint class="text-danger ms-2">Should be 13 digit</mat-hint>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.confirmationNumber
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                type="number"
                formControlName="confirmationNumber"
                placeholder="{{'pages.AddRetailer.Enterconfirmationnumber' | translate }}"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row g-0">
      <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 align-self-center">
        <h4 class="form-item-label" translate>
          Retailer Language
        </h4>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 align-self-center">
        <div class="form-item-input">
          <mat-form-field appearance="outline">
            <mat-select formControlName="language">
              <mat-option value="English">
                English
              </mat-option>
              <mat-option value="Spanish">
                Spanish
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      </div>
      <!--  
            <div class="row g-0">
        <div
          class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
        >
          <h4 class="form-item-label" translate>
            Status<span class="required">*</span>
          </h4>
        </div>
        <div
          class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
        >
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <mat-select formControlName="retailerStatus" placeholder="{{'pages.AddProviders.SelectStatus' | translate }}">
                <mat-option value="Active">Active</mat-option>
                <mat-option value="InActive">InActive</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>    -->  
    </div>
    <h5 class="content-label-each" translate>
      pages.newRetailer.accountInformation
    </h5>
    <div class="account-info-details content-details-blk">
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.accountType<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-radio-group (change)="radioChange($event)" [formControl]="accountType">
              <mat-radio-button color="primary" value="Prepaid" 
                ><span translate
                  >pages.newRetailer.prepaid</span
                ></mat-radio-button
              >
              <mat-radio-button color="primary" value="Postpaid" 
                ><span translate
                  >pages.newRetailer.postpaid</span
                ></mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.paymentOption<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-radio-group formControlName="paymentOption">
              <mat-radio-button color="primary" value="ACH"
                >{{ 'pages.placeholders.ACH' | translate }} &nbsp; &nbsp;
              </mat-radio-button>
              <mat-radio-button color="primary" value="Credit Card"
                ><span translate
                  >pages.newRetailer.creditCard</span
                ></mat-radio-button
              >
              <mat-radio-button color="primary" value="Deposit"
                ><span translate
                  >pages.newRetailer.deposit</span
                ></mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.invoiceOption<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-radio-group formControlName="invoiceOption">
              <mat-radio-button color="primary" value="Weekly"
                ><span translate
                  >pages.newRetailer.weekly</span
                ></mat-radio-button
              >
              <mat-radio-button color="primary" value="Daily"
                ><span translate
                  >pages.newRetailer.daily</span
                ></mat-radio-button
              >
              <mat-radio-button color="primary" value="Semi-weekly"
                ><span translate
                  >pages.newRetailer.semiWeekly</span
                ></mat-radio-button
              >
              <mat-radio-button color="primary" value="Bi-Weekly"
                ><span translate
                  >pages.newRetailer.biWeekly</span
                ></mat-radio-button
              >
              <mat-radio-button color="primary" value="Monthly"
                ><span translate
                  >pages.newRetailer.monthly</span
                ></mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.firstName<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                required
                [textMask]="{ mask: charMask, guide: false }"
                formControlName="firstName"
                placeholder="{{'pages.AddRetailer.Enterfirstname' | translate }}"
              />
            </mat-form-field>
            <div *ngIf="f.firstName.touched && f.firstName.invalid">
              <div *ngIf="f.firstName.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Firstnameisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.lastName<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                required
                [textMask]="{ mask: charMask, guide: false }"
                formControlName="lastName"
                placeholder="{{'pages.AddRetailer.Enterlastname' | translate }}"
              />
            </mat-form-field>
            <div *ngIf="f.lastName.touched && f.lastName.invalid">
              <div *ngIf="f.lastName.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Lastnameisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.userName<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                required
                [textMask]="{ mask: allCharWithAmprecendMask, guide: false }"
                formControlName="userName"
                placeholder="{{
                  'pages.newRetailer.enterUsername' | translate
                }}"
              />
            </mat-form-field>
            <div *ngIf="f.userName.touched && f.userName.invalid">
              <div *ngIf="f.userName.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Usernameisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.mobileNumberForOTP<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline" class="p-0">
              <input
                matInput
                [textMask]="{ mask: phone }"
                required
                placeholder="{{
                  'pages.newRetailer.enterMobilenumber' | translate
                }}"
                formControlName="otpMobileNumber"
              />
              <!-- <span matPrefix>+1</span> -->
            </mat-form-field>
            <div *ngIf="f.otpMobileNumber.touched && f.otpMobileNumber.invalid">
              <div *ngIf="f.otpMobileNumber.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.MobileNumberisrequired' | translate }}</mat-hint
                >
              </div>
              <div *ngIf="f.otpMobileNumber.errors.pattern">
                <mat-hint class="text-danger ms-2"
                  >{{ 'pages.placeholders.PleaseEnter10digitMobileNumber' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.emailInput<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                required
                placeholder="{{'pages.AddRetailer.EnteremailAddress' | translate }}"
                formControlName="email"
              />
            </mat-form-field>
            <div *ngIf="f.email.touched && f.email.invalid">
              <div *ngIf="f.email.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.EmailIdisrequired' | translate }}</mat-hint
                >
              </div>
              <div *ngIf="f.email.errors.pattern">
                <mat-hint class="text-danger ms-2"> {{ 'pages.placeholders.Invalidformat' | translate }}</mat-hint>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.salesRepDist<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <mat-select
                formControlName="assignSalesReps"
                placeholder="{{'pages.AddRetailer.SelectsalesRepDist' | translate }}"
                (selectionChange)="onsalesrepSelected($event)"
              >
                <mat-option
                  *ngFor="let salesRep of salesReps"
                  [value]="salesRep.userId"
                >
                  {{ salesRep.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="f.assignSalesReps.touched && f.assignSalesReps.invalid">
              <div *ngIf="f.assignSalesReps.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ "pages.AddRetailer.DistributorRepIsRequired" | translate }}.</mat-hint
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.pricelist<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <mat-select
                formControlName="assignPriceList"
                placeholder="{{'pages.AddRetailer.SelectPricelist' | translate }}"
              >
                <mat-option
                  *ngFor="let pricelist of pricelists"
                  [value]="pricelist"
                >
                  {{ pricelist }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="f.assignPriceList.touched && f.assignPriceList.invalid">
              <div *ngIf="f.assignPriceList.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Pricelistassignmentisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
        
       
      </div>
      <div class="row g-0">
        
         <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.OfTransactionsHr<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <mat-select
                formControlName="transactionCountPerhr"
                placeholder="{{ 'pages.placeholders.Settransactionlimit' | translate }}"
              >
                <mat-option
                  *ngFor="let limit of transactionPerHr"
                  [value]="limit"
                >
                  {{ limit }}/Hr
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div
              *ngIf="
                f.transactionCountPerhr.touched &&
                f.transactionCountPerhr.invalid
              "
            >
              <div *ngIf="f.transactionCountPerhr.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.TransactionLimitisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.transactionAmtHr<span class="required">*</span>
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <mat-select
                formControlName="transactionAmtPerhrLimit"
                placeholder="{{ 'pages.placeholders.Setamountlimit' | translate }}"
              >
                <mat-option
                  *ngFor="let limitAmount of transactionAmtPerhr"
                  [value]="limitAmount"
                >
                  {{ limitAmount | currency }}/Hr
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div
              *ngIf="
                f.transactionAmtPerhrLimit.touched &&
                f.transactionAmtPerhrLimit.invalid
              "
            >
              <div *ngIf="f.transactionAmtPerhrLimit.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.AmountLimitisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.OfTransactionsHr<span class="required"
              >*</span
            >
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <mat-select
                formControlName="offTransactionCountPerhr"
                placeholder="{{ 'pages.placeholders.SelectOffHourstransactions' | translate }}"
                #tooltip="matTooltip"
                matTooltip="Off-hours: 11 p.m - 6 a.m"
                matTooltipPosition="right"
                aria-tooltip="Button that displays and hides a tooltip triggered by other buttons"
              >
                <mat-option
                  *ngFor="let transactionCount of offHoursTransactionCount"
                  [value]="transactionCount"
                >
                  {{ transactionCount }}/Hr
                </mat-option>
              </mat-select>
              <mat-hint class="mt-3">Off-hours: 11 pm - 6 am </mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.transactionAmtHr<span class="required"
              >*</span
            >
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <mat-select
                formControlName="offTransactionAmtPerhr"
                placeholder="{{ 'pages.placeholders.SelectOffHourstransactionamount' | translate }}"
              >
                <mat-option
                  *ngFor="let transactionAmount of offHoursTransactionAmount"
                  [value]="transactionAmount"
                >
                  {{ transactionAmount | currency }}
                </mat-option>
              </mat-select>
              <mat-hint class="mt-3">Off-hours: 11 pm - 6 am </mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row g-0 my-3">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.threshold<span
              *ngIf="autoReloadStatus"
              class="required"
              >*</span
            >
          </h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <div class="form-item-input">
            <mat-form-field appearance="outline">
              <mat-select
                formControlName="threshold"
                placeholder="{{'pages.AddRetailer.Selectthresholdamount' | translate }}"
              >
                <mat-option>--</mat-option>
                <mat-option
                  *ngFor="let amount of thresholdAmount"
                  [value]="amount"
                >
                  {{ amount | currency }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="f.threshold.touched && f.threshold.invalid">
              <div *ngIf="f.threshold.errors.required">
                <mat-hint class="text-danger ms-2">
                  {{ 'pages.placeholders.Thresholdamountisrequired' | translate }}</mat-hint
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>pages.newRetailer.autorelaodamount</h4>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-3 align-self-center">
          <div class="form-item-toggle">
            <mat-slide-toggle
              color="primary"
              class="mb-2"
              formControlName="autoReloadStatus"
              (change)="checkautoReloadStatus($event)"
            ></mat-slide-toggle>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-3 col-sm-3 col-xs-9 align-self-center"
          *ngIf="autoReloadStatus"
        >
          <mat-form-field appearance="outline" class="mat-field-split-right">
            <input matInput
            [textMask]="{ mask: numberMask, guide: false }" 

              placeholder="{{'pages.Creditlinebalance.Autoreloadamount' | translate }}"
              formControlName="autoReloadAmount" 
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row g-0" *ngIf="addRetailerForm.get('accountType').value=='Postpaid' ">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>Auto Payment Status</h4>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-3 align-self-center">
          <div class="form-item-toggle">
            <mat-slide-toggle
              color="primary"
              class="mb-2"
              formControlName="autoPaymentStatus"
              (change)="checkautoPaymentStatus($event)"
            ></mat-slide-toggle>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
          <h4 class="form-item-label">
            {{ "pages.AddRetailer.InitialBalance" | translate }} <span *ngIf="creditLineStatusreq" class="required">*</span
          >
          </h4>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-2 col-xs-12 align-self-center">
          <div class="form-item-toggle">
            <mat-slide-toggle
              color="primary"
              class="mb-2"
              [disabled]="accountType.value == 'Prepaid'" 
              formControlName="creditLineStatus"
              (change)="checkIsCreditline($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
          *ngIf="creditLineStatus"
        >
          <mat-form-field appearance="outline">
            
            <input
              matInput
              placeholder="{{ 'pages.placeholders.Creditline' | translate }}"
              formControlName="createCreditLine"
              [textMask]="{ mask: numberMask, guide: false }"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row  g-0">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <h5 class="content-label-each" translate>pages.newRetailer.registration</h5>
    <div class="registration-info-details content-details-blk">
      <div class="row g-0">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 align-self-center">
          <h4 class="form-item-label" translate>pages.newRetailer.ipAddress</h4>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 align-self-center">
          <div class="form-item-toggle">
            <mat-slide-toggle
              color="primary"
              class="mb-2"
              formControlName="ipAddressStatus"
              (change)="checkIpAddressStatus($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7 align-self-center"
          *ngIf="ipAddressStatus"
        >
        <div class="form-item-input mx-2">
          <mat-form-field appearance="outline" class="w-100">
            <input
              matInput
              placeholder="{{ 'pages.newRetailer.ipAddress' | translate }}"
              type="text"
              formControlName="ipAddress" 
            />
          </mat-form-field>
        </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 align-self-center">
          <h4 class="form-item-label" translate>pages.newRetailer.IVRnumber</h4>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-2 col-xs-4 align-self-center">
          <div class="form-item-toggle">
            <mat-slide-toggle
              color="primary"
              class="mb-2"
              formControlName="ivrAccess"
              (change)="checkIsIvr($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-4 col-sm-4 col-xs-5 align-self-center"
          *ngIf="ivrAccess"
        >
          <div class="form-item-input mx-2">
            <mat-form-field appearance="outline" class="w-100 ">
              <input
                matInput
                type="text"
                [textMask]="{ mask: phone }"
                placeholder="{{ 'pages.newRetailer.IVRnumber' | translate }}"
                formControlName="ivrNumber"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12" *ngIf="ivrAccess">
          <div class="form-item-input">
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                type="text"
                pattern="[0-9]*"
                maxlength="4"
                placeholder="4 digit code"
                formControlName="ivrCode"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
         <h5 class="content-label-each" translate>pages.newRetailer.notification</h5>
    <div class="notification-info-details content-details-blk">
      <div class="row g-0">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>pages.newRetailer.textMessage</h4>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-3 align-self-center">
          <div class="form-item-toggle">
            <mat-slide-toggle
              color="primary"
              class="mb-2"
              formControlName="smsNotificationStatus"
              (change)="checkIsTextNotify($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
          <h4 class="form-item-label" translate>
            pages.newRetailer.emailInput
          </h4>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-3 align-self-center">
          <div class="form-item-toggle">
            <mat-slide-toggle
              color="primary"
              class="mb-2"
              formControlName="emailNotificationStatus"
              (change)="checkEmailNotificationStatusNotify($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
  
   
    <div class="form-footer">
      <ul class="list-inline text-center">
        <li class="list-inline-item">
          <button
            mat-raised-button
            [disabled]="!addRetailerForm.valid"
            color="primary"
            type="submit"
            class="rounded-0"
          >
            <span translate class="translate">pages.newRetailer.save</span>
          </button>
        </li>
        <li class="list-inline-item">
          <button
           mat-stroked-button
            color="primary"
            type="button"
            class="rounded-0"
            (click)="onCancel()"
          >
            <span translate class="translate">pages.newRetailer.cancel</span>
          </button>
        </li>
      </ul>
    </div>
  </form>
</div>
